<template>
  <div>
    <div
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="loading"
      v-if="loading"
    ></div>
    <div class="main box-shadow-default apply-wc" v-else>
      <div class="main-top flex flex-a_c flex-j_c">
        <div class="wc-icon">
          <i v-show="success" class="el-icon-circle-check"></i>
          <i v-show="fail" class="el-icon-circle-close"></i>
        </div>
        <div class="wc-text" v-show="fail">
          <span class="big-black">申请失败！</span>
          <span>请先完成身份认证再提交申请！</span>
        </div>
        <div class="wc-text" v-show="success">
          <span class="big-black">恭喜您申请成功!</span>
          <span>请在5个工作日内到{{ selectedBsdtTitle }}办理</span>
        </div>
        <div class="wc-text" v-show="checked">
          <span class="big-black">业务状态为审核中，请勿重新提交申请！</span>
        </div>
      </div>
      <div class="wc-content" v-show="success">
        <div class="left-wc">
          <span class="small-black">
            您的申请编号：
            <span>{{ flowInfoIng.wwywh }}</span>
            <br />
            <p v-show="bjbh !== ''">
              办件编号：<span>{{ bjbh }} </span>
              <br />
            </p>
            申请事项：
            <span>{{ name }}</span>
            <br />
            <p v-show="$hasPermission('IEBDC:SQ:WC:YSSX')">
              申请人：
              <span>{{ applicantPerson }}</span>
              <br />
            </p>
            <p v-show="$hasPermission('IEBDC:SQ:WC:YSSX')">
              预审时限：
              <span>{{ yssx }}工作日</span>
              <br />
            </p>
            <p v-show="$hasPermission('IEBDC:SQ:WC:BLSX')">
              办理时限：
              <span>请在{{ blsx }}工作日内到办事大厅办理</span>
              <br />
            </p>
            <p>
              可打印文件：
              <span class="color2C8BFF mr10">打印申请表</span>
              <span class="color2C8BFF">打印受理凭证</span>
              <br />
            </p>
            <p v-show="$hasPermission('IEBDC:SQ:WC:XDCL')">
              必须携带材料为：
              <span class="color2C8BFF">{{ fileReuired }}(材料详情请查看办事指南)</span>
              <br />温馨提示：我们将尽快进行资料预审核，请关注后续消息提醒。
            </p>
          </span>
        </div>
        <div class="right-wx">
          <div class="wc-ewm" v-show="$hasPermission('IEBDC:GNXS:WXGZH')">
            <span>微信扫码在手机获取申请表</span>
            <br />
            <img :src="sqsEwmImg" />
          </div>
        </div>
      </div>
      <div class="main-footer text-center" v-if="success">
        <el-button type="primary" @click="applyAgain()">继续申请</el-button>
        <el-button type="primary" @click="$router.push('/')">返回首页</el-button>
        <el-button type="primary" v-if="$hasPermission('IEBDC:DYQX:DYSQB')" @click="printApply()">打印申请表</el-button>
        <el-button type="primary" v-if="$hasPermission('IEBDC:DYQX:DYSLPZ')" @click="estatePrintApply()">打印受理凭证</el-button>
      </div>
      <div class="main-footer text-center" v-if="fail">
        <el-button type="primary" @click="backRz()">返回认证列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import { uniqBy } from 'lodash';
import applicantFinishService from '@/pages/iebdc/api/apply/applicant-finish';
import applicantUploadService from '@/pages/iebdc/api/apply/applicant-upload';
import { printApply, estatePrintApply } from '@/pages/iebdc/api/my-application.js';
import utils from '@/utils/utils';
export default {
  name: 'finish',
  data() {
    return {
      name: '', //预审事项
      yssx: '', //预审时限
      blsx: '', //办理时限
      bjbh: '', //办件编号
      sqsEwmImg: '',
      fileReuired: '', //必须上传的材料
      success: false, //申请成功显示
      fail: false, //有未认证人员显示
      checked: false, //业务为审核状态显示
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['selectedBsdtCode', 'selectedBsdtTitle']),
    ...mapState('wysq-data', ['flowInfoIng', 'processData']),
    // 选择的流程类型信息
    ...mapState('wysq-data', ['firstFlow']),
    // 申请人展示
    applicantPerson() {
      // 权利人集合
      const qlr = this.processData && this.processData[0] && this.processData[0].qlrs;
      // 义务人集合
      const ywr = this.processData && this.processData[0] && this.processData[0].ywrs;
      // 去除重复名称
      const qlrs = uniqBy(qlr, 'qlrmc');
      const ywrs = uniqBy(ywr, 'ywrmc');
      const qlrNameList = (qlrs || []).reduce((acc, cur) => {
        acc = `${acc}${acc ? ' ' : ''}${cur.qlrmc || cur.name}`;
        return acc;
      }, '');
      const ywrNameList = (ywrs || []).reduce((acc, cur) => {
        acc = `${acc}${acc ? ' ' : ''}${cur.ywrmc || cur.name}`;
        return acc;
      }, '');
      //
      return `${qlrNameList || ''}  ${ywrNameList || ''}`;
    },
  },
  created() {
    this.targetToStep('完成');
    this.name = this.flowInfoIng.subname || this.firstFlow.thirdTypeData.name;
    //获取当前业务状态
    this.getProcessInfo();
  },
  methods: {
    // 跳转到下一页面
    ...mapMutations('wysq-step', ['targetToStep']),
    // 更新流程信息
    ...mapMutations('wysq-data', ['setFlowInfoIng']),
    //获取流程详细信息
    async getProcessInfo() {
      if (!this.flowInfoIng.wwywh) return;
      await applicantUploadService.getProcessInfo({ wwywh: this.flowInfoIng.wwywh }).then((res) => {
        const { success, data, message } = res;
        if (success && data) {
          if (data.step === 'NETCHECKING') {
            this.checked = true;
            // this.$message.error('该业务已经处于审核状态，请勿重复提交申请！');
            return false;
          } else {
            // this.fail = true;
            //获取申请完成数据
            this.completeApply();
            //获取办事大厅数据
            this.$hasPermission('IEBDC:SQ:WC:BLSX') && this.getBsdtDetail();
            //获取需携带材料
            this.$hasPermission('IEBDC:SQ:WC:XDCL') && this.getFileList(this.flowInfoIng.subcode);
          }
        } else {
          this.$message.error(message);
        }
      });
    },
    completeApply() {
      this.loading = true;
      applicantFinishService
        .completeApply({ qlxxId: this.flowInfoIng.id })
        .then((res) => {
          console.log(this.loading, 'loading');
          if (res.success && res.data) {
            this.loading = false;
            this.success = true;
            const params = Object.assign({}, this.flowInfoIng);
            params.id = res.data.qlxxId;
            params.ywh = res.data.ywh[0];
            params.wwywh = res.data.wwywh;
            // 调用vuex，更新数据对象
            this.setFlowInfoIng(params);
            this.yssx = res.data.yssx;
            this.bjbh = res.data.projectNo;
            //获取申请二维码
            // this.$hasPermission('IEBDC:GNXS:WXGZH') && this.getSqsEwm();
            this.getSqsEwm();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
          if (err.message.includes('当前存在未认证状态人员')) {
            this.fail = true;
          }
        });
    },
    //获取办事大厅详情
    async getBsdtDetail() {
      const { success, data } = await applicantFinishService.getBsdtDetail({ officeCode: this.selectedBsdtCode });
      if (success && data) {
        this.blsx = data.blsx;
      } else {
        this.$message.error(data.message);
      }
    },
    //获取携带材料
    async getFileList(code) {
      const { success, data } = await applicantFinishService.getFileList({ subCode: code });
      if (success && data) {
        this.fileData = data.filter(({ sfbx }) => sfbx);
        let tempArr = [];
        this.fileData.forEach((item) => {
          tempArr.push(item.clmc);
        });
        this.fileReuired = tempArr.join('，');
      } else {
        this.$message.error(data.message);
      }
    },
    //获取申请二维码
    async getSqsEwm() {
      const { success, data } = await applicantFinishService.getSqsEwm({ ywh: this.flowInfoIng.wwywh });
      if (success && data) {
        this.sqsEwmImg = data;
      } else {
        this.$message.error(data.message);
      }
    },
    //返回认证列表
    backRz() {
      this.targetToStep('身份认证');
      this.$router.push({
        name: 'authorizedCertify',
        params: { ywh: this.flowInfoIng.wwywh },
      });
    },
    //打印申请表
    printApply() {
      printApply({ ywh: this.flowInfoIng.wwywh }).then((res) => {
        if (res.success) {
          window.open(res.data);
        } else {
          this.$message.error('打印失败');
        }
      });
    },
    estatePrintApply() {
      estatePrintApply({ ywh: this.flowInfoIng.wwywh }).then((res) => {
        if (res.success === true) {
          window.open(res.data);
        } else {
          this.$message.error('打印失败');
        }
      });
    },
    //继续申请
    applyAgain() {
      this.targetToStep('阅读须知');
      this.$router.push({
        name: 'apply',
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/styles/common-variables';
@import 'src/styles/public';
.loading {
  width: 100%;
  height: 300px;
}
.main {
  padding: 20px 120px;
  line-height: 40px;
  letter-spacing: 1px;
  background-color: #ffffff;
  p {
    margin: 0 0 10px;
    text-align: justify;
    text-justify: inter-ideograph;
    &.weight {
      font-weight: 700;
      color: rgba(85, 85, 85, 1);
    }
  }
}
.el-icon-error {
  color: red;
}
.main-top {
  line-height: 108px;
  width: 916px;
  div {
    display: inline-block;
  }
  span {
    font-size: 24px;
    color: #333333;
    font-weight: bolder;
  }
  .wc-icon {
    width: 100px;
    color: #72c901;
    i {
      font-size: 68px;
      float: right;
      margin: 20px;
      color: #2c8bff;
    }
  }
}

.apply-wc {
  flex: 1;
  margin-top: 20px;
  .wc-content {
    margin: 20px 0px;
    padding: 20px;
    display: flex;
    background: #fafafa;
    .left-wc {
      width: 50%;
      padding-right: 20px;
    }
    .right-wx {
      width: 50%;
      position: relative;
      border-left: 1px dashed #e5e5e5;
      padding-right: 20px;
    }
    .wc-ewm {
      position: absolute;
      left: 50%;
      margin-left: -100px;
      width: 200px;
      height: 256px;
      top: 50%;
      margin-top: -128px;
      span {
        display: inline-block;
        position: absolute;
        bottom: 0;
        font-weight: 800;
        font-size: 14px;
        width: 200px;
        text-align: center;
      }
    }
  }
}
//智能审批相关样式
.intelligent {
  width: 100%;
  .title {
    height: 50px;
    line-height: 50px;
    background: #f3f3f3;
    padding: 0 150px;
    font-size: 15px;
  }
  .lineH {
    line-height: 40px;
  }
  .result {
    padding: 20px 150px;
    border-bottom: 1px solid #dddddd;
    .success {
      span {
        color: #72c901;
        font-size: 16px;
        i {
          margin: 0 10px 10px 0;
        }
      }
    }
    .fail {
      span {
        color: #f56c6c;
        font-size: 16px;
        i {
          margin: 0 10px 10px 0;
        }
      }
    }
    .radius {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: block;
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .SUCCESS {
      background-color: #0076ff;
    }
    .ERROR {
      background-color: #ffb100;
    }
    .WARNNING {
      background-color: #fe5658;
    }
  }
}
/deep/ .el-table th {
  height: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
/deep/ .el-table tr {
  td,
  th {
    text-align: center;
    position: relative;
  }
}
</style>
